import { useEffect, useRef, useState } from "react";

const items = [
  { label: "Start Project Request", href: "/#/get-quotes", primary: true },
  { label: "Contractor Sign Up", href: "/#/contractors/pricing" },
  { label: "Contractor Login", href: "/#/contractors/login" },
  { label: "Blog", href: "/#/blog" },
  { label: "Terms of Use", href: "/#/terms" },
  { label: "Privacy Policy", href: "/#/privacy" },

];

export default function NavMoreMenu() {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  // Close on Esc
  useEffect(() => {
    function onKeyDown(e) {
      if (e.key === "Escape") setOpen(false);
    }
    if (open) document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open]);

  return (
    <div className="relative" ref={containerRef}>
      <button
        type="button"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 rounded-full border border-zinc-600 px-3 py-1 text-sm font-medium text-zinc-200 hover:bg-zinc-800 transition"
      >
        More <span className="text-zinc-400">{open ? "▴" : "▾"}</span>
      </button>

      {open && (
        <div
          role="menu"
          className="absolute right-0 mt-2 z-50 w-[min(92vw,18rem)] rounded-2xl border border-zinc-700 bg-zinc-900 shadow-xl overflow-hidden"
        >
          <div className="p-2">
            {items.map((item) => {
              const base =
                "block w-full rounded-xl px-3 py-2.5 text-sm font-medium transition";
              const cls = item.primary
                ? "bg-orange-600 text-white hover:bg-orange-700"
                : "text-zinc-200 hover:bg-zinc-800";

              return (
                <a
                  key={item.href}
                  href={item.href}
                  role="menuitem"
                  className={`${base} ${cls}`}
                  onClick={() => setOpen(false)}
                >
                  {item.label}
                </a>
              );
            })}
          </div>

          <div className="border-t border-zinc-700 bg-zinc-800 px-4 py-3 text-[11px] text-zinc-400">
            No suits. No push. Just get it fixed.
          </div>
        </div>
      )}
    </div>
  );
}
